import { Box, Divider, Tooltip } from '@material-ui/core';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

interface IOrderSummary {
  date: number;
  totalPrice?: string;
}

export const OrderSummary: React.FC<IOrderSummary> = ({ totalPrice, date }) => {
  const { formatMessage } = useIntl();

  const day = dayjs(date).format('dddd D MMM');
  const hour = dayjs(date).format('hh:mm a');

  return (
    <Box color="#000">
      <Divider style={{ margin: '24px 0px' }} />
      <Box display="flex" flexDirection="column" style={{ gap: 11 }}>
        <Box display="flex" justifyContent="space-between">
          <Box fontSize="14px" fontWeight="500">
            {formatMessage({
              id: 'Ws.Catalogue.shoppingCart.detail.sumary.day',
            })}
          </Box>
          <Box color="#959595" style={{ textTransform: 'capitalize' }}>
            {day}
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Box fontSize="14px" fontWeight="500">
            {formatMessage({
              id: 'Ws.Catalogue.shoppingCart.detail.sumary.hour',
            })}
          </Box>
          <Box color="#959595">{hour}</Box>
        </Box>
      </Box>
      <Divider style={{ margin: '27px 0px 13px 0px' }} />
      <Tooltip
        title={
          !totalPrice
            ? formatMessage({
                id: 'Ws.Catalogue.shoppingCart.totalPrice.error.message',
              })
            : ''
        }
        placement="bottom-start"
      >
        <Box display="flex" justifyContent="space-between">
          <Box fontSize="14px" fontWeight="500">
            {formatMessage({
              id: 'Ws.Catalogue.shoppingCart.detail.sumary.total',
            })}
          </Box>
          <Box fontSize="14px" fontWeight="700">
            {totalPrice || 'N/A'}
          </Box>
        </Box>
      </Tooltip>
      <Divider style={{ marginTop: '11px' }} />
    </Box>
  );
};

export default OrderSummary;
